import { Action, Reducer } from "redux";
import { AppThunkAction } from "./";
import { Registration, RegistrationRefData } from "../entities/RegistrationEntities";

// -----------------------------------------------------------------------------------------------
// state

export interface RegistrationState {
    registration: Registration;
    referenceData: RegistrationRefData;
}

// ------------------------------------------------------------------------------------------------
// actions

const SET_REGISTRATION = 'SET_REGISTRATION';

const SET_REGISTRATION_REFDATA = 'SET_REGISTRATION_REFDATA';

interface SetRegistrationAction {
    type: typeof SET_REGISTRATION;
    registration: Registration;
}

interface SetRegistrationRefDataAction {
    type: typeof SET_REGISTRATION_REFDATA;
    referenceData: RegistrationRefData;
}

type KnownAction = SetRegistrationAction | SetRegistrationRefDataAction;

export const actionCreators = {

    setRegistration: (registration: Registration): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: SET_REGISTRATION,
            registration
        });
    },

    setRegistrationRefData: (referenceData: RegistrationRefData): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({
            type: SET_REGISTRATION_REFDATA,
            referenceData
        });
    }
};

// ------------------------------------------------------------------------------------------------
// reducer

export const reducer: Reducer<RegistrationState, KnownAction> = (state: RegistrationState | undefined, incomingAction: Action): RegistrationState => {
    if (state === undefined) {
        return {
            registration: null,
            referenceData: null
        };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SET_REGISTRATION:
            return {
                ...state,
                registration: action.registration
            };
        case SET_REGISTRATION_REFDATA:
            return {
                ...state,
                referenceData: action.referenceData
            };
        default:
            return state;
    }
};
